export default __webpack_public_path__ + "static/branding-tab-22bcc1ce2cadf2f2c31d8bd26a8608a8.svg";